// extracted by mini-css-extract-plugin
export var backdropBlur = "_em-0";
export var contentCard = "_em-5";
export var frame = "_em-2";
export var image = "_em-4";
export var imagePane = "_em-3";
export var modal = "_em-1";